export default __webpack_public_path__ + "static/media/Chevron.4bda7fb2.svg";